import React from 'react';

const Skeleton = ({ className = '' }) => (
  <div className={`animate-pulse rounded-xl bg-cream-200/70 ${className}`} aria-hidden="true" />
);

export default Skeleton;
